import { BackendModel, BackendService } from '../../core/backend.service';

export class Permission extends BackendModel {

  static path = '/permisos/';

  name?: string;
  displayName?: string;
  description?: string;

  constructor(protected backendService: BackendService, model?: Permission) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/security/permission/permission.model.ts